import { render, staticRenderFns } from "./SuccessBizum.vue?vue&type=template&id=2ae1b9bd&scoped=true&"
import script from "./SuccessBizum.vue?vue&type=script&lang=js&"
export * from "./SuccessBizum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae1b9bd",
  null
  
)

export default component.exports